import {
  showShortcutsListenerContainer
} from '../shortcutsListener';
import { ESystemHotKeys, IShortcutHandler } from './types';
import { CaptionsShortcutHandler } from './handlers/captionsShortcutHandler';

export class ShortcutManager {

  private static captionsHandler: IShortcutHandler = new CaptionsShortcutHandler();

  private static disableTargetInputs = ['input', 'textarea'];

  public static keyDown(event: KeyboardEvent) {
    if (!ShortcutManager.checkHandleHotKey(event)) return;

    const keyCode = event.code as ESystemHotKeys;
    if (ESystemHotKeys.SPACE === keyCode) {
      event.preventDefault();
    } else if ((event.ctrlKey || event.metaKey) &&
      event.key.toLowerCase() === 'c'
    ) {
      const selection = window.getSelection();
      const text = selection?.toString() || '';

      if (text && navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text);
      }
    }
  }

  public static keyUp(event: KeyboardEvent) {
    if (!ShortcutManager.checkHandleHotKey(event)) return;

    const keyCode = event.code as ESystemHotKeys;
    const systemHotKeys = Object.values(ESystemHotKeys);
    if (systemHotKeys.includes(keyCode)) {
      showShortcutsListenerContainer();
    }
    ShortcutManager.captionsHandler.handle(keyCode);
  }

  private static checkHandleHotKey(event: KeyboardEvent): boolean {
    const element = event.target as HTMLElement;
    const isInput = ShortcutManager.disableTargetInputs.includes(element.tagName.toLowerCase());
    if (isInput) return false;

    const isContenteditable = element.hasAttribute('contenteditable');
    if (isContenteditable) return false;

    const dataNohotkey = element.dataset?.nohotkey;
    if (dataNohotkey) return false;

    return true;
  }

}
